import {
  Environment,
  Store,
  RecordSource,
  Network,
  FetchFunction,
} from 'relay-runtime';

const fetchGraphQL: FetchFunction = async (request, variables) => {
  const resp = await fetch('/gateway/api/graphql', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: request.text, variables }),
  });
  if (!resp.ok) {
    throw new Error('Response failed.');
  }
  return resp.json();
};

export const environment = new Environment({
  store: new Store(new RecordSource({})),
  network: Network.create(fetchGraphQL),
});
